export const RADIUS = 6378137;
export const EQUATOR = 2 * Math.PI * RADIUS;
export const SUBEQUATOR = 1 / EQUATOR;
export const HALF_EQUATOR = EQUATOR / 2;
